var device = null
;(function () {
  'use strict'

  function hex4(n) {
    let s = n.toString(16)
    while (s.length < 4) {
      s = '0' + s
    }
    return s
  }

  function hexAddr8(n) {
    let s = n.toString(16)
    while (s.length < 8) {
      s = '0' + s
    }
    return '0x' + s
  }

  function niceSize(n) {
    const gigabyte = 1024 * 1024 * 1024
    const megabyte = 1024 * 1024
    const kilobyte = 1024
    if (n >= gigabyte) {
      return n / gigabyte + 'GiB'
    } else if (n >= megabyte) {
      return n / megabyte + 'MiB'
    } else if (n >= kilobyte) {
      return n / kilobyte + 'KiB'
    } else {
      return n + 'B'
    }
  }

  async function fixInterfaceNames(device_, interfaces) {
    // Check if any interface names were not read correctly
    if (interfaces.some((intf) => intf.name == null)) {
      // Manually retrieve the interface name string descriptors
      let tempDevice = new dfu.Device(device_, interfaces[0])
      await tempDevice.device_.open()
      let mapping = await tempDevice.readInterfaceNames()
      await tempDevice.close()

      for (let intf of interfaces) {
        if (intf.name === null) {
          let configIndex = intf.configuration.configurationValue
          let intfNumber = intf['interface'].interfaceNumber
          let alt = intf.alternate.alternateSetting
          intf.name = mapping[configIndex][intfNumber][alt]
        }
      }
    }
  }

  function getDFUDescriptorProperties(device) {
    // Attempt to read the DFU functional descriptor
    return device.readConfigurationDescriptor(0).then(
      (data) => {
        let configDesc = dfu.parseConfigurationDescriptor(data)
        let funcDesc = null
        let configValue = device.settings.configuration.configurationValue
        if (configDesc.bConfigurationValue == configValue) {
          for (let desc of configDesc.descriptors) {
            if (
              desc.bDescriptorType == 0x21 &&
              desc.hasOwnProperty('bcdDFUVersion')
            ) {
              funcDesc = desc
              break
            }
          }
        }

        if (funcDesc) {
          return {
            WillDetach: (funcDesc.bmAttributes & 0x08) != 0,
            ManifestationTolerant: (funcDesc.bmAttributes & 0x04) != 0,
            CanUpload: (funcDesc.bmAttributes & 0x02) != 0,
            CanDnload: (funcDesc.bmAttributes & 0x01) != 0,
            TransferSize: funcDesc.wTransferSize,
            DetachTimeOut: funcDesc.wDetachTimeOut,
            DFUVersion: funcDesc.bcdDFUVersion,
          }
        } else {
          return {}
        }
      },
      (error) => {}
    )
  }

  // Current log div element to append to
  let logContext = null

  function setLogContext(div) {
    logContext = div
  }

  function clearLog(context) {
    if (typeof context === 'undefined') {
      context = logContext
    }
    if (context) {
      context.innerHTML = ''
    }
  }

  function logDebug(msg) {
    console.log(msg)
  }

  function logInfo(msg) {
    if (logContext) {
      let info = document.createElement('div')
      info.className = 'info'
      info.textContent = msg
      logContext.appendChild(info)
    }
  }

  function logWarning(msg) {
    if (logContext) {
      let warning = document.createElement('p')
      warning.className = 'warning'
      warning.textContent = msg
      logContext.appendChild(warning)
    }
  }

  function logError(msg) {
    if (logContext) {
      let error = document.createElement('p')
      error.className = 'error'
      error.textContent = msg
      logContext.appendChild(error)
    }
  }

  function logProgress(done, total) {
    if (logContext) {
      let progressBar
      if (logContext.lastChild.tagName.toLowerCase() == 'progress') {
        progressBar = logContext.lastChild
      }
      if (!progressBar) {
        progressBar = document.createElement('progress')
        logContext.appendChild(progressBar)
      }
      console.log(done, '**************done')
      progressBar.value = done
      if (typeof total !== 'undefined') {
        progressBar.max = total
      }
      console.log(progressBar, '***************progressBar')
    }
  }

  document.addEventListener('DOMContentLoaded', (event) => {

    let modalTararira = document.querySelector('#page-tararira-update')
    let page1 = document.querySelector('#page-1')
    let page2 = document.querySelector('#page-2')
    let page3 = document.querySelector('#page-3')
    let page4 = document.querySelector('#page-4')
    let connectButton = document.querySelector('#connect')

    let updateButton = document.querySelector('#update')
    // var firmList = document.querySelector('.firm-list')
    let vidField = document.querySelector('#vid')

    let vid = 279
    let prodId = 0x0001

    let serial = ''

    let transferSize = 2048
    let firmwareFile = null

    let downloadLog = document.querySelector('#downloadLog')
    setLogContext(downloadLog)
    logInfo()
    logProgress(7, 10)
    let uploadLog = document.querySelector('#uploadLog')

    let manifestationTolerant = true

    function fadeIn(node, duration) {
      if (getComputedStyle(node).display !== 'none') return
      if (node.style.display === 'none') {
        node.style.display = ''
      } else {
        node.style.display = 'block'
      }
      node.style.opacity = 0
      var start = performance.now()
      requestAnimationFrame(function tick(timestamp) {
        var easing = (timestamp - start) / duration
        node.style.opacity = Math.min(easing, 1)
        if (easing < 1) {
          requestAnimationFrame(tick)
        } else {
          node.style.opacity = ''
        }
      })
    }

    fadeIn(modalTararira, 500)

    function onDisconnect(reason) {
      if (reason) {
        alert(reason)
        console.log(reason)
      }
      connectButton.textContent = 'Connect'
    }

    function onUnexpectedDisconnect(event) {
      if (device !== null && device.device_ !== null) {
        if (device.device_ === event.device) {
          device.disconnected = true
          onDisconnect('Device disconnected')
          device = null
        }
      }
    }

    async function connect(device) {
      try {
        await device.open()
      } catch (error) {
        onDisconnect(error)
        throw error
      }

      // Attempt to parse the DFU functional descriptor
      let desc = {}
      try {
        desc = await getDFUDescriptorProperties(device)
      } catch (error) {
        onDisconnect(error)
        throw error
      }

      if (desc && Object.keys(desc).length > 0) {
        device.properties = desc
        page1.style.display = 'none'
        fadeIn(page2, 500)
        transferSize = desc.TransferSize
        if (desc.CanDnload) {
          manifestationTolerant = desc.ManifestationTolerant
        }
      }

      // Bind logging methods
      device.logDebug = logDebug
      device.logInfo = logInfo
      device.logWarning = logWarning
      device.logError = logError
      device.logProgress = logProgress

      // Clear logs
      clearLog(uploadLog)
      clearLog(downloadLog)

      updateButton.disabled = false
      return device
    }

    function autoConnect(vid, serial) {
      dfu.findAllDfuInterfaces().then(async (dfu_devices) => {
        let matching_devices = []
        for (let dfu_device of dfu_devices) {
          if (serial) {
            if (dfu_device.device_.serialNumber == serial) {
              matching_devices.push(dfu_device)
            }
          } else if (dfu_device.device_.vendorId == vid) {
            matching_devices.push(dfu_device)
          }
        }

        if (matching_devices.length == 0) {
          //statusDisplay.textContent = 'No device found.';
          console.log('No device found.')
        } else {
          if (matching_devices.length == 1) {
            //statusDisplay.textContent = 'Connecting...';
            console.log('Connecting...')
            device = matching_devices[0]
            //console.log(device);
            device = await connect(device)
          } else {
            //statusDisplay.textContent = "Multiple DFU interfaces found.";
            console.log('Multiple DFU interfaces found.')
          }
          vidField.value =
            '0x' + hex4(matching_devices[0].device_.vendorId).toUpperCase()
          vid = matching_devices[0].device_.vendorId
        }
      })
    }

    connectButton.addEventListener('click', function () {
      if (device) {
        device.close().then(onDisconnect)
        device = null
      } else {
        let filters = []
        if (serial) {
          filters.push({
            serialNumber: serial,
          })
        } else if (vid) {
          filters.push({
            vendorId: vid,
          })
          if (prodId) {
            filters[0].productId = prodId
          }
        }
        navigator.usb
          .requestDevice({
            filters: filters,
          })
          .then(async (selectedDevice) => {
            let interfaces = dfu.findDeviceDfuInterfaces(selectedDevice)
            if (interfaces.length == 0) {
              alert(
                'Error: The selected device does not have any USB DFU interfaces.'
              )
              console.log(
                'Error: The selected device does not have any USB DFU interfaces.'
              )
            } else if (interfaces.length != 1) {
              alert('Error: An invalid device is connected.')
              console.log('Error: An invalid device is connected.')
            } else {
              await fixInterfaceNames(selectedDevice, interfaces)
              async function connectToSelectedInterface() {
                device = await connect(
                  new dfu.Device(selectedDevice, interfaces[0])
                ) // ここでaltインターフェイス決定
              }
              connectToSelectedInterface()
            }
          })
          .catch((error) => {
            alert(error)
            console.log(error)
          })
      }
    })

    // firmList.addEventListener('click', selectfirm, false)
    function selectfirm(e) {
      let targetFile = document.querySelector('.firm-active')
      targetFile.classList.remove('firm-active')
      e.target.classList.add('firm-active')
    }

    updateButton.addEventListener('click', async function () {
      event.preventDefault()
      event.stopPropagation()
      firmwareFile = null
      page2.style.display = 'none'
      fadeIn(page3, 500)
      let targetFile = document.querySelector('.firm-active')
      // let name = targetFile.getAttribute('data-url')
      let name = binaryFilePath
      // var ref = firebase.storage().ref().child(name)
      // await ref.getDownloadURL().then(function (url) {
      fetch(name)
        .then(function (response) {
          return response.blob()
        })
        .then(function (blob) {
          let reader = new FileReader()
          reader.onload = function () {
            firmwareFile = reader.result
            startDownload()
          }
          reader.readAsArrayBuffer(blob)
        })
      // })
    })

    async function startDownload() {
      if (device && firmwareFile != null) {
        setLogContext(downloadLog)
        clearLog(downloadLog)
        try {
          let status = await device.getStatus()
          if (status.state == dfu.dfuERROR) {
            await device.clearStatus()
          }
        } catch (error) {
          device.logWarning('Failed to clear status')
        }
        await device
          .do_download(transferSize, firmwareFile, manifestationTolerant)
          .then(
            () => {
              navigator.usb.removeEventListener(
                'disconnect',
                onUnexpectedDisconnect
              )
              device.detach()
              page3.style.display = 'none'
              fadeIn(page4, 500)
              setLogContext(null)
              if (!manifestationTolerant) {
                device.waitDisconnected(5000).then(
                  (dev) => {
                    onDisconnect()
                    device = null
                  },
                  (error) => {
                    // It didn't reset and disconnect for some reason...
                    console.log('Device unexpectedly tolerated manifestation.')
                  }
                )
              }
            },
            (error) => {
              logError(error)
              setLogContext(null)
            }
          )
      }
    }

    // Check if WebUSB is available
    if (typeof navigator.usb !== 'undefined') {
      navigator.usb.addEventListener('disconnect', onUnexpectedDisconnect)
    } else {
      alert(
        'WebUSB not available.\nThe firmware updater cannot be used with this browser.'
      )
      console.log(
        'WebUSB not available.\nThe firmware updater cannot be used with this browser.'
      )
      connectButton.disabled = true
    }
  })
})()
